import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import ForceChangePassword from "@/components/ForceChangePassword";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import IHResponse from "@/pages/IHResponse";
import ConfirmarRecomendacion from "@/pages/ConfirmarRecomendacion";
import IHPortal from "@/pages/IHPortal";
import IHSetPassword from "@/pages/IHSetPassword";
import Dashboard from "@/pages/Dashboard";
import Wizard from "@/pages/Wizard";
import ApplicationResult from "@/pages/ApplicationResult";
import AdditionalInfo from "@/pages/AdditionalInfo";
import Recomendaciones from "@/pages/Recomendaciones";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminFicha from "@/pages/admin/AdminFicha";
import AdminBenefitTable from "@/pages/admin/AdminBenefitTable";
import AdminConfig from "@/pages/admin/AdminConfig";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminRegistrados from "@/pages/admin/AdminRegistrados";
import AdminStats from "@/pages/admin/AdminStats";
import AdminHistorial from "@/pages/admin/AdminHistorial";
import AdminRecordatorios from "@/pages/admin/AdminRecordatorios";
import AdminBuscarFamilia from "@/pages/admin/AdminBuscarFamilia";
import Manual from "@/pages/Manual";
import ManualUsuario from "@/pages/manual/ManualUsuario";
import ManualEvaluador from "@/pages/manual/ManualEvaluador";

const APPLICANT = ["applicant"];
const STAFF = ["evaluator", "admin", "superadmin"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <ImpersonationBanner />
        <ForceChangePassword />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ingresar" element={<Login />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/recuperar" element={<ForgotPassword />} />
          <Route path="/restablecer" element={<ResetPassword />} />
          <Route path="/ih-respuesta" element={<IHResponse />} />
          <Route path="/recomendacion" element={<ConfirmarRecomendacion />} />
          <Route path="/portal-ih" element={<IHPortal />} />
          <Route path="/portal-ih/clave" element={<IHSetPassword />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/manual-usuario" element={<ManualUsuario />} />
          <Route path="/manual-evaluador" element={<ProtectedRoute roles={STAFF}><ManualEvaluador /></ProtectedRoute>} />

          <Route path="/panel" element={<ProtectedRoute roles={APPLICANT}><Dashboard /></ProtectedRoute>} />
          <Route path="/solicitud/:id" element={<ProtectedRoute roles={APPLICANT}><Wizard /></ProtectedRoute>} />
          <Route path="/solicitud/:id/resultado" element={<ProtectedRoute roles={APPLICANT}><ApplicationResult /></ProtectedRoute>} />
          <Route path="/solicitud/:id/informacion" element={<ProtectedRoute roles={APPLICANT}><AdditionalInfo /></ProtectedRoute>} />
          <Route path="/solicitud/:id/recomendaciones" element={<ProtectedRoute roles={APPLICANT}><Recomendaciones /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={STAFF}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/estadisticas" element={<ProtectedRoute roles={STAFF}><AdminStats /></ProtectedRoute>} />
          <Route path="/admin/registrados" element={<ProtectedRoute roles={STAFF}><AdminRegistrados /></ProtectedRoute>} />
          <Route path="/admin/historial" element={<ProtectedRoute roles={STAFF}><AdminHistorial /></ProtectedRoute>} />
          <Route path="/admin/recordatorios" element={<ProtectedRoute roles={STAFF}><AdminRecordatorios /></ProtectedRoute>} />
          <Route path="/admin/buscar-familia" element={<ProtectedRoute roles={STAFF}><AdminBuscarFamilia /></ProtectedRoute>} />
          <Route path="/admin/solicitud/:id" element={<ProtectedRoute roles={STAFF}><AdminFicha /></ProtectedRoute>} />
          <Route path="/admin/tabla" element={<ProtectedRoute roles={STAFF}><AdminBenefitTable /></ProtectedRoute>} />
          <Route path="/admin/config" element={<ProtectedRoute roles={STAFF}><AdminConfig /></ProtectedRoute>} />
          <Route path="/admin/auditoria" element={<ProtectedRoute roles={STAFF}><AdminAudit /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
